"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _agent = require("@deosite/agent");
var _mapCategories = _interopRequireDefault(require("@deosite/helpers/mapCategories"));
var _searchTree = _interopRequireDefault(require("@deosite/helpers/searchTree"));
var fetcher = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(lang) {
    var categoriesData;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _agent.requests.get(global.__appConfig__.categoriesWithImagesUrl, true, null, lang);
          case 2:
            categoriesData = _context.sent;
            categoriesData = (0, _searchTree["default"])(categoriesData, global.__appConfig__.menuSelectByCategoryID, true);
            return _context.abrupt("return", (0, _mapCategories["default"])(categoriesData));
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function fetcher(_x) {
    return _ref.apply(this, arguments);
  };
}();
var _default = fetcher;
exports["default"] = _default;